import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { KeepAppointmentActions } from 'app/components/keep-appointment';
import { UnsafeAction } from 'app/actions/UnsafeAction';

/* tslint:disable */
@Injectable()
export class KeepAppointmentEffect {

	constructor(private updates$: Actions) { }

	@Effect() setKeepAppointment$ = this.updates$
		.ofType(KeepAppointmentActions.SET_KEEP_APPOINTMENT)
		.do((action: UnsafeAction) => {
			localStorage.setItem("eventStorageId", JSON.stringify(action.payload.eventStorageId));
			localStorage.setItem("timestamp", JSON.stringify(action.payload.timestamp));
			localStorage.setItem("userSetHasVisualQuota", JSON.stringify(action.payload.userSetHasVisualQuota));
		})
		.ignoreElements()
}



// WEBPACK FOOTER //
// ./src/app/components/keep-appointment/keep-appointment.effect.ts